<template>
  <div class="i-seat-multi-picker">
    <i-multi-picker
      ref="picker"
      label-counter="seat(s)"
      :label="label"
      :value="value"
      :fetch-options="fetchSeats"
      :disabled="disabled"
      option-label="name"
      option-value="id"
      @input="$val => $emit('input',$val)"
      @open="onOpen"
      @search-change="onHighlight"
      @keydown.native="onKeydown"
    />
  </div>
</template>

<script>
import {list as listMicrosoftSeats} from "@/services/api/app/seat-management/seat";
import {list as listGoogleSeats} from "@/services/api/app/google/seat-management/seat";
import {list as listDropboxSeats} from "@/services/api/app/dropbox/seat-management/seat"
import {list as listBoxSeats} from "@/services/api/app/box/seat-management/seat";
import IMultiPicker from "@/components/common/forms/IMultiPicker";

export default {
  name: 'ISeatMultiPicker',
  components: {IMultiPicker},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Seats'
    },
    placeholder: {
      type: String,
      default: 'Search all seats'
    },
    providerTenant: {
      type: String,
      default: 'MICROSOFT'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: null,
      seats: []
    }
  },

  methods: {
    fetchSeats({search}) {
      let list = listMicrosoftSeats;
      if (this.providerTenant === 'GOOGLE') {
        list = listGoogleSeats;
      } else if (this.providerTenant === 'DROPBOX') {
        list = listDropboxSeats;
      } else if (this.providerTenant === 'BOX') {
        list = listBoxSeats;
      }

      return list({
        pagination: {
          pageNumber: 1,
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then((data) => {
          return data
        })
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView)
    },

    onHighlight() {
      this.$nextTick(this.scrollHighlightedIntoView)
    },

    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView)
      }
    },

    scrollHighlightedIntoView() {
      const picker = this.$refs.picker
      const wrapper = picker.$el.querySelector(
        '.multiselect__content-wrapper'
      )
      const highlighted = wrapper.querySelector(
        '.multiselect__option--highlight'
      )
      if (highlighted) {
        // scroll just enough to make it appear
        highlighted.scrollIntoView({ block: 'nearest' })
      }
    }
  }
}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
